//react
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
//siblings
import {getConfig} from '../config';
import {ServiceBase} from '../../components/service';
import { extendedstyles } from '../appstyles';

import {ReportBase,getReport} from '../reports';
import {UploadBase,getUpload} from '../uploads';

const extrastyles = (theme:Theme) => ({});

const styles = extendedstyles(extrastyles);


class Main extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;

  isCustomPage(page:any){
    return false;
  }

  // renderCustom() {
  //   console.log('In Main.render()');
  //   const {page,service,code,showNotification,setPage,setHome,classes, theme, ...others} = this.props;
  //   const title = "Main Records";
  //   const configuration = getConfig(service); 
  //   const xservice = React.cloneElement(<ServiceBase />,{
  //     title,
  //     service,
  //     code,
  //     configuration,
  //     setPage,
  //     setHome,
  //     showNotification,
  //     classes,
  //     theme,
  //     ...others
  //   });
  //   return (xservice);
  // }

  isReportPage(page:any){
    const rep = getReport(page);
    return (rep !== undefined);
  }

  // renderReport() {
  //   const {page,service,code,showNotification,setPage,setHome,classes, theme, ...others} = this.props;
  //   console.log(`In Main.Report.render() ${service}`);
  //   const title = "Main Records";
  //   const configuration = getConfig(service); 
  //   console.log(`In Main.Report.render().conf ${configuration}`);
  //   const rservice = React.cloneElement(<ReportBase />,{
  //     title,
  //     service,
  //     code,
  //     configuration,
  //     setPage,
  //     setHome,
  //     showNotification,
  //     classes,
  //     theme,
  //     ...others
  //   });
  //   return (rservice);
  // }

  isUploadPage(page:any){
    const rep = getUpload(page);
    return (rep !== undefined);
    //return false;
  }

  // renderUpload() {
  //   const {page,service,code,showNotification,setPage,setHome,classes, theme, ...others} = this.props;
  //   console.log(`In Main.Upload.render() ${service}`);
  //   const title = "Upload Records";
  //   const configuration = getConfig(service); 
  //   console.log(`In Main.Upload.render().conf ${configuration}`);
  //   const rservice = React.cloneElement(<UploadBase />,{
  //     title,
  //     service,
  //     code,
  //     configuration,
  //     setPage,
  //     setHome,
  //     showNotification,
  //     classes,
  //     theme,
  //     ...others
  //   });
  //   return (rservice);
  // }

  // renderDefault() {
  //   console.log('In Main.render()');
  //   const {page,service,code,showNotification,setPage,setHome,classes, theme, ...others} = this.props;
  //   const title = "Main Records";
  //   const configuration = getConfig(service); 
  //   const xservice = React.cloneElement(<ServiceBase />,{
  //     title,
  //     service,
  //     code,
  //     configuration,
  //     setPage,
  //     setHome,
  //     showNotification,
  //     classes,
  //     theme,
  //     ...others
  //   });
  //   return (xservice);
  // }

  renderPage(Base:any) {
    console.log('In Main.render()');
    const {page,service,code,showNotification,setPage,setHome,classes, theme, ...others} = this.props;
    const title = "Main Records";
    const configuration = getConfig(service); 
    const xservice = React.cloneElement(<Base />,{
      title,
      service,
      code,
      configuration,
      setPage,
      setHome,
      showNotification,
      classes,
      theme,
      ...others
    });
    return (xservice);
  }
  // render0(){
  //   const {service:page} = this.props;
  //   if(this.isCustomPage(page)) {
  //     return this.renderCustom();
  //   }
  //   else if(this.isReportPage(page)) {
  //     return this.renderReport();
  //   }
  //   else {
  //     return this.renderDefault();
  //   }
  // }

  render(){
    const {service:page} = this.props;
    let Base = ServiceBase;
    if(this.isCustomPage(page)) {
      Base = ServiceBase;
    }
    else if(this.isReportPage(page)) {
      Base = ReportBase;
    }
    else if(this.isUploadPage(page)) {
      Base = UploadBase;
    }
    else {
      Base = ServiceBase;
    }
    return this.renderPage(Base);
  }
}

Main.propTypes = {
  service: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  setPage: PropTypes.func,
  setHome: PropTypes.func,
  showNotification: PropTypes.func
};

export default withStyles(styles, { withTheme: true })(Main);
